import React, { useEffect, useState } from "react";
import {
  ChatBaloon,
  ChatContainer,
  ChatExample,
  GptBody,
  GptContainer,
  GptContent,
  IconContainer,
  OptionExample,
  Title,
} from "./styled";
import { Animation, FormSpacer, Icon } from "ui/styled";
import Input from "components/Form/Input";

export default function ChatAgent() {
  const [messages, setMessages] = useState([]);

  const [form, setForm] = useState({});
  const formValue = (ref) => {
    return form?.[ref] ? form?.[ref] : "";
  };
  const changeForm = (value, ref) => {
    setForm({ ...form, [ref]: value });
  };

  const example = [
    { title: "Qual a cotação do Euro?" },
    { title: "O que é cotação" },
    { title: "Oque é reserva" },
  ];

  const askExample = async (message) => {
    pushMessage({ message, me: true });
    await askGPT(message);
  };

  const sentGPT = async () => {
    if (form?.message?.length) {
      const message = form?.message;
      setForm({});
      pushMessage({ message, me: true, createdAt: new Date() });
      await askGPT(message);
    }
  };
  const askGPT = async (message) => {
    // const input = [...messages, { message }]
    //   ?.map((m) => m?.message)
    //   ?.join("\n");
    // const result = await PostGPT({ input });
    // const pResult = isValidJSON(result) ? JSON.parse(result) : result;
    // if (result && !exposeStrapiError(pResult)) {
    //   pushMessages([
    //     { message, me: true, createdAt: new Date() },
    //     {
    //       message: `${result || ""}`?.replace("\n", "<br />"),
    //       createdAt: new Date(),
    //     },
    //   ]);
    // }
  };

  const pushMessage = (message) => {
    setMessages((currentMessages) => [...currentMessages, message]);
  };

  const scrollToBottom = () => {
    const div = document.getElementById("gpt");
    div.scrollTop = div.scrollHeight;
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  return (
    <>

      <GptContainer isMessage={messages?.length}>
        <ChatContainer>

          <GptContent>
            {/* <Icon icon="logo-blue" width={"300px"} /> */}
            <Animation animationData={require('assets/lotties/Artificial-Intelligence.json')} />
          </GptContent>
          <FormSpacer large />
          <IconContainer>
            {/* <Icon icon="balloons" width={'50px'} /> */}
            {messages?.length ? null :
              <>
                <Title>Perguntas Frequentes</Title>
              </>
            }
          </IconContainer>
          <FormSpacer large />
          {messages?.length ? null : (
            <GptContent>
              <ChatExample>
                {example.map((item, index) => (
                  <OptionExample
                    key={item.title}
                    onClick={() => askExample(item.title)}
                  >
                    {item.title}
                  </OptionExample>
                ))}
              </ChatExample>
            </GptContent>
          )}
          <GptBody id={"gpt"}>
            {messages?.map((m, k) => (
              <ChatBaloon
                key={`${m?.createdAt || 'message'}-${m?.message || ''}-${k}`}
                me={m?.me}
                dangerouslySetInnerHTML={{ __html: m?.message }}
              />
            ))}
          </GptBody>
          <FormSpacer />
        </ChatContainer>
        <Input
          endIcon={<Icon icon='send' />}
          holder
          white
          placeholder="Digite sua mensagem"
          send={sentGPT}
          onSubmitEditing={sentGPT}
          value={formValue("message")}
          onChange={(e) => changeForm(e.target.value, "message")}
        />
      </GptContainer>
    </>
  );
}
